import { useEffect, useCallback } from 'react'
import SheetClipCls from 'sheetclip'
import { CvsChipInput } from '@components/chip-input'
import { Operator } from '@global/constants'
import { t } from '@lingui/core/macro'

const SheetClip = new SheetClipCls()

export interface onChangeParam {
  target: { value: string[] | string }
}

interface Props {
  filterIndex: number
  filterValue: string[] | string
  operator: Operator
  onChange: (number) => (obj: onChangeParam) => void
}

export function ColumnFilterPopoverMultiValueInput({
  filterIndex,
  filterValue,
  operator,
  onChange,
}: Props) {
  useEffect(() => {
    if (typeof filterValue !== 'string') return

    onChange(filterIndex)({ target: { value: [] } })
  }, [operator])

  const onPaste = e => {
    const data = e.clipboardData.getData('Text')
    const parsed = SheetClip.parse(data)
    const asItems = parsed.flatMap(row => row).map(item => item.trim())
    const withoutDups = [filterValue, ...asItems].reduce(
      (memo, value) => {
        if (memo.seen[value]) {
          return memo
        }
        memo.seen[value] = true
        memo.items.push(value)
        return memo
      },
      { seen: {}, items: [] },
    )
    onChange(filterIndex)({ target: { value: withoutDups.items } })
    e.target.blur()
  }

  // Does not allow for duplicates.
  const onAdd = useCallback(
    value => {
      if (!filterValue.includes(value)) {
        onChange(filterIndex)({ target: { value } })
      }
    },
    [filterValue],
  )

  return (
    <div style={{ width: '100%' }}>
      <CvsChipInput
        placeholder={t`Enter a value`}
        label={t`Values`}
        value={Array.isArray(filterValue) ? filterValue : filterValue ? [filterValue] : []}
        onChange={onAdd}
        allowDuplicates={false}
        fullWidth
        variant="standard"
        size="small"
        InputProps={{
          onPaste,
        }}
      />
    </div>
  )
}
